'use client'
import { useState } from "react";
import BlogListLayout from "./BlogListLayout";

const ListLayout = ({ posts }: { posts: Array<any> }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  // Helper to parse 'DD-MM-YYYY HH:mm:ss' to Date
  function parseCustomDate(dateStr: string): Date {
    const match = dateStr.match(/(\d{2})-(\d{2})-(\d{4})(?:[ T](\d{2}):(\d{2}):(\d{2}))?/);
    if (!match) return new Date(dateStr);
    const [ dd, mm, yyyy, hh = '00', min = '00', ss = '00'] = match;
    return new Date(`${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`);
  }

  const sortedPosts = [...posts].sort((a, b) => {
    return parseCustomDate(b.frontMatter.created_at).getTime() - parseCustomDate(a.frontMatter.created_at).getTime();
  });

  const filteredPosts = sortedPosts.filter((post) =>
    post.frontMatter.page_title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  return (
    <>

      {/* Search Bar */}
      <div className="offcanvas__search !p-5 flex justify-center items-center w-full h-full">
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearch}
          placeholder="Search blog..."
          className="w-full max-w-[400px] p-2 border rounded"

        />
      </div>

      <BlogListLayout posts={filteredPosts} />
    </>
  );
};

export default ListLayout;
